export default "__VITE_ASSET__D8vgo4pB__"